import { type FunctionComponent } from 'react';
import { ErrorRecovery } from '../../components/ErrorRecovery/ErrorRecovery';
import { PrayerStream } from '../../components/PrayerStream/PrayerStream';
import { useTranslation } from '../../i18n/resources';
import styles from './PrayerStreamPage.module.css';

export const PrayerStreamPage: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.desktop}>
        <PrayerStream />
      </div>
      <div className={styles.mobile}>
        <ErrorRecovery message={t('common', 'desktop_only_message')} />
      </div>
    </div>
  );
};
